import { useAuthRuntime } from "@frontend/components/auth/auth-runtime"
import { type ReactNode, useEffect, useRef } from "react"

interface AuthGuardProps {
  children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isLoading, isAuthenticated, error, login } = useAuthRuntime()
  const loginRequestedRef = useRef(false)

  useEffect(() => {
    if (isLoading || isAuthenticated || loginRequestedRef.current) {
      return
    }

    loginRequestedRef.current = true
    void login()
  }, [isAuthenticated, isLoading, login])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-xl text-center space-y-2">
          <p className="text-sm text-destructive">Authentication failed.</p>
          <p className="text-xs text-muted-foreground break-words">{error}</p>
        </div>
      </div>
    )
  }

  if (isLoading || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <p className="text-sm text-muted-foreground">Signing you in...</p>
      </div>
    )
  }

  return <>{children}</>
}
